import { queryCarDayWorkTime, selectCarWorkList, selectAllCarAndWorkTime, SelectTodayProblemCountPage, queryFaultCountPeriod, queryFaultCountPeriodRate, queryFaultPageByCar, selectCarOrder,selectCarOrderList,SelectTodayWorkTimePage,SelectUseRatePage,selectDailyUseRate } from "../../api/config/modules/VehicleAnalysis";

const state = {
    selectCarOrder: {},
    selectCarOrderList: {},
    SelectTodayWorkTimePage: {},
    SelectUseRatePage: {},
    selectDailyUseRate: {},
    SelectTodayProblemCountPage: {},
    queryFaultCountPeriod: {},
    queryFaultCountPeriodRate: {},
    queryFaultPageByCar: {},
    selectAllCarAndWorkTime: {},
    queryCarDayWorkTime: {},
    selectCarWorkList: {}
};

const mutations = {
  SET_CARRANKORDER: (state, selectCarOrder) => {
    state.selectCarOrder = selectCarOrder;
  },
  SET_CARORDERLIST: (state, selectCarOrderList) => {
    state.selectCarOrderList = selectCarOrderList;
  },
  SET_TODAYWORKTIMEPAGE: (state, SelectTodayWorkTimePage) => {
    state.SelectTodayWorkTimePage = SelectTodayWorkTimePage;
  },
  SET_USERATEPAGE: (state, SelectUseRatePage) => {
    state.SelectUseRatePage = SelectUseRatePage;
  },
  SET_DAILYUSERATE: (state, selectDailyUseRate) => {
    state.selectDailyUseRate = selectDailyUseRate;
  },
  SET_SELECTTODAYPROBLEMCOUNTPAGE: (state, SelectTodayProblemCountPage) => {
    state.SelectTodayProblemCountPage = SelectTodayProblemCountPage;
  },
  SET_QUERYFAULTCOUNTPERIOD: (state, queryFaultCountPeriod) => {
    state.queryFaultCountPeriod = queryFaultCountPeriod;
  },
  SET_QUERYFAULTCOUNTPERIODRATE: (state, queryFaultCountPeriodRate) => {
    state.queryFaultCountPeriodRate = queryFaultCountPeriodRate;
  },
  SET_QUERYFAULTPAGEBYCAR: (state, queryFaultPageByCar) => {
    state.queryFaultPageByCar = queryFaultPageByCar;
  },
  SET_SELECTALLCARANDWORKTIME: (state, selectAllCarAndWorkTime) => {
    state.selectAllCarAndWorkTime = selectAllCarAndWorkTime;
  },
  SET_QUERYCARDAYWORKTIME: (state, queryCarDayWorkTime) => {
    state.queryCarDayWorkTime = queryCarDayWorkTime;
  },
  SET_SELECTCARWORKLIST: (state, selectCarWorkList) => {
    state.selectCarWorkList = selectCarWorkList;
  }
};

const actions = {
  GET_CARRANKORDER: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        selectCarOrder(data)
        .then((res) => {
          commit("SET_CARRANKORDER", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_CARORDERLIST: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      selectCarOrderList(data)
        .then((res) => {
          commit("SET_CARORDERLIST", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_TODAYWORKTIMEPAGE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      SelectTodayWorkTimePage(data)
        .then((res) => {
          commit("SET_TODAYWORKTIMEPAGE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_USERATEPAGE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      SelectUseRatePage(data)
        .then((res) => {
          commit("SET_USERATEPAGE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_DAILYUSERATE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      selectDailyUseRate(data)
        .then((res) => {
          commit("SET_DAILYUSERATE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_SELECTTODAYPROBLEMCOUNTPAGE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      SelectTodayProblemCountPage(data)
        .then((res) => {
          commit("SET_SELECTTODAYPROBLEMCOUNTPAGE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_QUERYFAULTCOUNTPERIOD: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      queryFaultCountPeriod(data)
        .then((res) => {
          commit("SET_QUERYFAULTCOUNTPERIOD", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_QUERYFAULTCOUNTPERIODRATE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      queryFaultCountPeriodRate(data)
        .then((res) => {
          commit("SET_QUERYFAULTCOUNTPERIODRATE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_QUERYFAULTPAGEBYCAR: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      queryFaultPageByCar(data)
        .then((res) => {
          commit("SET_QUERYFAULTPAGEBYCAR", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_SELECTALLCARANDWORKTIME: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      selectAllCarAndWorkTime(data)
        .then((res) => {
          commit("SET_SELECTALLCARANDWORKTIME", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_QUERYCARDAYWORKTIME: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      queryCarDayWorkTime(data)
        .then((res) => {
          commit("SET_QUERYCARDAYWORKTIME", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_SELECTCARWORKLIST: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      selectCarWorkList(data)
        .then((res) => {
          commit("SET_SELECTCARWORKLIST", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
